<section *ngIf="tabIndex === 0 && !isViewOpen" class="tab-pane">
  <div class="show fade partner_content" id="createPartnerContTab">
    <div class="d-flex flex-column h-100">
      <div id="createPartnerDataHeader" class="data_header">
        <div id="createPartnerLeft" class="left_side_section">
          <div class="results_info">
            <div id="createPartnerTitle" class="title"><span i18n="@@create-partner-content.title.partnerContent">Partner Content</span></div>
            <div id="createPartnerContGroup" class="results">
              <span i18n="@@create-partner-content.pagination.showing">Showing <strong>{{showFrom}} -
                  {{showTo}}</strong> of
                <strong>{{paginationCount}} Partner Content Groups</strong></span>
            </div>
          </div>
          <div id="createPartnerSearchGrp" class="search_group" *ngIf="(hasData || !hasSearchData) && !onlyNotHasData">
            <div id="createPartnerSearchInput" class="input-group">
              <input type="text" id="partnerContentSearch" class="form-control" placeholder="{{searchByContentName}}"
                #searchValue [(ngModel)]="searchData" (ngModelChange)="clearSearch(searchData)"
                (keyup.enter)="searchContentsonEnter(searchData)" />
              <img class="search-clear-icon" alt="close" *ngIf="searchClose && searchData?.length" (click)="clearSearchDirect()" />
            </div>
            <button type="button" class="btn btn-primary search_btn gtmPartnerContentSearch"
              (click)="searchContentName(searchData)">
              <img class="search_icon" alt="search" />
            </button>
          </div>
          <iposcen-spinner-overlay></iposcen-spinner-overlay>
        </div>
        <div id="createPartnerActionBtn" class="action_buttons" *ngIf="hasData || hasSearchData">
          <button type="button" class="
                btn btn-primary btn-lg
                left_icon_btn
                gtmAssetLibraryPromoContentNewPromoContentContent
              " (click)="createPartnerContent()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span i18n="@@create-partner-content.header.new-contentgroup">New Content Group</span>
          </button>
        </div>
      </div>

      <!-- Filters -->
      <div id="createPartnerFilterOptn" class="filter_options" *ngIf="hasData|| hasSearchData">
        <form class="form-inline filter-option-width">
          <span i18n="@@create-partner-content.filter.filters"><strong>Filters</strong></span>
          <select *ngIf="!systemIdDropdownSelectedValue" #drop1 (change)="onFilter('systemIDfilter', drop1.value)"
            class="btn-greyscale btn-sm dropdown-toggle" aria-haspopup="true" aria-expanded="false">
            <option selected default hidden><span i18n="@@create-partner-content.filter.systemid">System ID</span></option>
            <option class="dropdown-item" *ngFor="let systemID of allSystemIdData" [value]="systemID">
              {{systemID}}
            </option>
          </select>
          <div class="dropdown-selected" *ngIf="systemIdDropdownSelectedValue">
            <div class="text-dropdown" ngbTooltip="{{systemIdDropdownSelectedValue}}">{{systemIdDropdownSelectedValue}}
            </div>
            <img class="dropdown-selected-img" (click)="clearFilter('systemIDfilter')" alt="close" />
          </div>
          <select *ngIf="!reviewStatusDropdownSelectedValue" #drop2
            (change)="onFilter('reviewStatusfilter', drop2.value)" class="btn-greyscale btn-sm dropdown-toggle"
            aria-haspopup="true" aria-expanded="false">
            <option selected default hidden><span i18n="@@create-partner-content.filter.status">Status</span></option>
            <option class="dropdown-item" *ngFor="let status of allreviewStatusData" [value]="status">
              {{checkSpell(status)}}
            </option>
          </select>
          <div class="dropdown-selected" *ngIf="reviewStatusDropdownSelectedValue">
            <div class="text-dropdown" ngbTooltip="{{checkSpell(reviewStatusDropdownSelectedValue)}}">
              {{checkSpell(reviewStatusDropdownSelectedValue)}}</div>
            <img class="dropdown-selected-img" (click)="clearFilter('reviewStatusfilter')" alt="close" />
          </div>
        </form>
      </div>
      <hr />


      <div id="noRecordFoundText" class="go-center" *ngIf="!displayContents.length && (!hasSearchData && !onlyNotHasData)">
        <span i18n="@@create-partner-content.screenmsg.norecord">No record found</span>
      </div>

      <div id="noPartnerContFoundText" class="go-center" *ngIf="!hasData && onlyNotHasData">
        <span i18n="@@create-partner-content.screenmsg.nopartnercontent">No Partner Content found. Please create a new
          <div>Content Group to display on your device.</div>
        </span>
        <div id="createPartnerContBtn" class="button-middle">
          <button type="button" class="
                btn btn-primary btn-lg
                left_icon_btn addButton
                gtmNewPartnerContent
              " (click)="createPartnerContent()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg> <span i18n="@@create-partner-content.header.new-contentgroup">New Content Group</span>
          </button>
        </div>

      </div>

      <!-- Table data -->
      <div id="createPartnerContData" *ngIf="hasData|| hasSearchData">
        <div id="createPartnerContTable" class="table-responsive">
          <table id="partnerContentsTable" aria-describedby="Content table" class="table table-borderless">
            <thead>
              <tr *ngIf="displayContents?.length">
                <th scope="col">
                  <span class="table_headings" (click)="sort('contentName')">
                    <span i18n="@@create-partner-content.tableheader.contentname">Content Name</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('systemID')">
                    <span i18n="@@create-partner-content.tableheader.systemid">System ID</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('languageCategory')">
                    <span i18n="@@create-partner-content.tableheader.category">Language Category</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('reviewStatus')">
                    <span i18n="@@create-partner-content.tableheader.status">Status</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('updatedTime')">
                    <span i18n="@@create-partner-content.tableheader.lastupdated">Last Updated</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('editedByName')">
                    <span i18n="@@create-partner-content.tableheader.lastupdatedby">Last Updated By</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of displayContents | slice: (page-1) * tableSize : page * tableSize">
                <tr>
                  <td>{{item.contentName}}</td>
                  <td>{{item.systemID}}</td>
                  <td>{{item.languageCategory}}</td>
                  <td class="review_status">
                    <div class="status_column">
                      <em *ngIf="item.reviewStatus === 'approved'" class="approved_icon"></em>
                      <em *ngIf="item.reviewStatus === 'submitted'" class="submitted_icon"></em>
                      <em *ngIf="item.reviewStatus === 'returned'" class="returned_icon"></em>
                      <span>
                        <span class="status_margin">
                          {{checkSpell(item.reviewStatus)}}
                        </span>
                        <img *ngIf="item.reviewStatus === 'approved'" class="info_circle_icon" placement="top"
                          [popoverTitle]="approvepop"
                          [ngbPopover]="approved_tooltip_text"
                          container="body" alt="" triggers="mouseenter:mouseleave" />
                        <img *ngIf="item.reviewStatus === 'submitted'" class="info_circle_icon" placement="top"
                          [popoverTitle]="submitpop"
                          [ngbPopover]="submitted_tooltip_text"
                          container="body" alt="" triggers="mouseenter:mouseleave" />
                        <img *ngIf="item.reviewStatus === 'returned'" class="info_circle_icon" placement="top"
                          [popoverTitle]="returnpop"
                          [ngbPopover]="returned_tooltip_text"
                          container="body" alt="" triggers="mouseenter:mouseleave" />
                        <img *ngIf="item.reviewStatus === 'saved'" class="info_circle_icon" placement="top"
                          [popoverTitle]="savedpop"
                          [ngbPopover]="saved_tooltip_text"
                          container="body" alt="" triggers="mouseenter:mouseleave" />
                      </span>
                    </div>
                  </td>
                  <td>{{item.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                  <td>{{item.editedByName}}</td>
                  <td class="action_cell">
                    <span class="modify_record">
                      <div *ngIf="item.reviewStatus !== 'submitted'" class="duplicate_record">
                        <img class="duplicate_icon" data-toggle="tooltip" data-placement="top" ngbTooltip={{duplicate}} alt="duplicate" (click)='editPartnerContent(item, "duplicate")' />
                      </div>
                      <div *ngIf="item.reviewStatus !== 'submitted'"
                        (click)="openDeleteModal(item.contentID, item.autoID)" class="delete_record cell_record"
                        data-toggle="modal" data-target="#deletePartnerContent1">
                        <img data-toggle="tooltip" data-placement="top" [ngbTooltip]="deleteTooltip" class="delete_icon"
                          alt="delete" />
                      </div>
                      <iposcen-delete-popup #deleteModal [contentName]="partnerContentToDeleteName"
                        [isPartnerContent]="true" (delete)="deletePartnerCG(partnerContentToDelete, autoIdOfPartnerCG)">
                      </iposcen-delete-popup>
                      <div *ngIf="item.reviewStatus !== 'submitted'" class="edit_record">
                        <img data-toggle="tooltip" data-placement="top" [ngbTooltip]="editTooltip"
                          (click)='editPartnerContent(item)' class="edit_icon" alt="edit" />
                      </div>
                      <div class="view_record">
                        <button *ngIf="item.reviewStatus !== 'saved'" (click)='openView(item.autoID,item.contentID)'
                          class="btn btn-link btn-teritiary left_icon_btn">
                          <img class="view_icon" alt="view" /><span
                            i18n="@@create-partner-content.table-data.view">View</span>
                        </button>
                      </div>
                      <div class="submit_record">
                        <button *ngIf="item.reviewStatus === 'saved'" (click)='submit(item.autoID,item.contentID)'
                          class="btn btn-link btn-teritiary left_icon_btn gtmsubmitcontentforapprovalauthor">
                          <img class="submit_icon gtmsubmitcontentforapprovalauthor" alt="submit" /><span
                            i18n="@@create-partner-content.table-data.submit" class="gtmsubmitcontentforapprovalauthor">Submit</span>
                        </button>
                      </div>
                    </span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <hr *ngIf="hasData|| hasSearchData" />
      <div id="PartnerContDataPagination"  class="data_footer position-relative" *ngIf="hasData|| hasSearchData">
        <div class="d-flex flex-column align-items-center" *ngIf="displayContents?.length > 0">
          <nav aria-label="content pagination">
            <ngb-pagination [collectionSize]="displayContents?.length" [(page)]="page" [pageSize]="tableSize" [rotate]="false"
              [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false" (pageChange)="onTableDataChange($event)">
            </ngb-pagination>
          </nav>
          <div class="results mt-2">
            <span i18n="@@create-partner-content.pagination.showing">Showing <strong>{{ showFrom }} - {{ showTo }}
              </strong> of <strong> {{ paginationCount }} Partner Content
                Groups</strong></span>
          </div>
        </div>
      </div>
    </div>
    <div id="languageSelected" *ngIf="isAllLanguagesSelected">
      <div id="modalDialog" class="modal-dialog modal-dialog-centered">
        <div id="documentModalDialog" class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-backdrop show"></div>
          <div class="modal" id="tileThumbnailPopup">
            <div class="modal-dialog">
              <div id="modalCloseSec" class="modal-content language_style">
                <div id="modalCloseIcon" class="close" data-dismiss="modal" (click)="closePopup()">
                  <img class="modal-close-icon" alt="close" />
                </div>
                <div id="modalBody" class="modal-body pb-0">
                  <div id="modalBodyText" class="d-flex align-items-center mb-4 adjustWidth">
                    The chosen Model SKU has already been associated with all languages. Edit the existing content
                    groups associated to the chosen Model SKU
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #approvepop>
    <div id="approvedIcon" class="d-flex"><em class="approved_icon mr-2"></em>
      <span i18n="@@create-partner-content.template.approved">Approved</span>
    </div>

  </ng-template>
  <ng-template #submitpop>
    <div id="submitIcon" class="d-flex"><em class="submitted_icon mr-2"></em>
      <span i18n="@@create-partner-content.template.submitted">Submitted</span>
    </div>

  </ng-template>
  <ng-template #returnpop>
    <div id="returnIcon" class="d-flex"><em class="returned_icon mr-2"></em>
      <span i18n="@@create-partner-content.template.returned">Returned</span>
    </div>

  </ng-template>
  <ng-template #savedpop>
    <div id="savedIcon" class="d-flex">
      <span i18n="@@create-partner-content.template.saved">Saved</span>
    </div>

  </ng-template>

  <!-- Partner content Submit success popup -->
  <div id="submitPopUp" class="container" *ngIf="isSubmit">
    <div id="successModalCont" class="modal-backdrop show"></div>
    <!-- The Modal -->
    <div class="modal" id="successAuthorModal">
      <div id="successModalDialog" class="modal-dialog modal-lg">
        <div id="successModalDialogContent" class="modal-content">
          <div class="card invitePopup">
            <div id="successModalHeader" class="modal-header">
              <div  id="successModalCloseIcon" class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="onCloseSubmitSuccessPopup()">
              </div>
            </div>
            <!-- Modal body -->
            <div  id="successModalBody" class="modal-body invitesuccess-panel">
              <div id="inviteSuccessImg" class="invitesuccess_img_div text-center">
                <span class="invitesuccess_img"></span>
              </div>
              <div id="inviteSuccessTitle" class="invitesuccess-title text-center">
                <span i18n="@@create-partner-content.template.submitted-for-approval">Submitted for Approval</span>
              </div>
              <div id="inviteSuccessCont" class="invitesuccess-content text-center"><span i18n="@@create-partner-content.template.admin-review">An Intel Admin will review your Content Group
                  shortly.</span></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Popup Modal ends Here -->
    </div>
  </div>




</section>




<div id="createPartnerContTab1" class="content__wrapper" *ngIf="tabIndex === 1">
  <!-- <div class="live_preview">
    <img class="herotile-default" alt="preview" />
  </div> -->
  <div id="cpTab1LivePreview" class="live_preview">
    <iposcen-content-live-preview [sidenav]="pageType">
    </iposcen-content-live-preview>
  </div>
</div>
<div id="cpTabsPreview" class="al_live_preview">
  <!-- Live preview - temporarly image -->
  <iposcen-partner-content-live-preview *ngIf="tabIndex === 2 || tabIndex === 3 || tabIndex === 4">
  </iposcen-partner-content-live-preview>
  <!-- Layout of preview -->
  <div id="cpTabsPreviewLayout" class="preview_layout" *ngIf="tabIndex === 2 || tabIndex === 3 || tabIndex === 4">
    <div id="cpTabsHotspotPreviewImg" class="card">
      <img [ngClass]="(lCGlayout === 4) ? 'hotspot_selected_layout4_img': 'hotspot_layout4_img'" alt="layout 4" (click)="setLayout(4)"
        class="cursor-pointer" />
    </div>
    <div id="cpTabsPreviewHotspotImgText" class="image-below-text"><span>Hotspots</span></div>
    <div id="cpTabsPreviewImg" class="card">
      <img [ngClass]="(lCGlayout === 1) ? 'img_layout-selected1': 'img_layout1'" alt="layout 1" (click)="setLayout(1)"
        class="cursor-pointer" />
    </div>
    <div id="cpTabsPreviewMultiImgText" class="image-below-text"><span i18n="@@create-partner-content.live-preview.multi-image">Multi-Image</span> </div>
    <div id="cpTabsPreviewLayout2" class="card">
      <img [ngClass]="(lCGlayout === 2) ? 'img_layout-selected2': 'img_layout2'" alt="layout 2" (click)="setLayout(2)"
        class="cursor-pointer" />
    </div>
    <div id="cpTabsPreviewLayout3" class="image-below-text"><span i18n="@@create-partner-content.live-preview.single-image">Single-Image</span></div>
    <div class="card">
      <img [ngClass]="(lCGlayout === 3) ? 'img_layout-selected3': 'img_layout3'" alt="layout 3" (click)="setLayout(3)"
        class="cursor-pointer" />
    </div>
    <div id="cpTabsPreviewLayoutVideo" class="image-below-text"><span i18n="@@create-partner-content.live-preview.video">Video</span></div>
  </div>
</div>
<ul *ngIf="(tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4)" class="nav nav-tabs" role="tablist">
  <li class="nav-item headers">
    <a class="nav-link gtmAssetLibraryPromoContentTitle" data-toggle="tab" [ngClass]="{'active': tabIndex === 1}"
      (click)="navigate()">
      <span>{{contentNameDisplay}}</span>
    </a>
  </li>
  <li class="nav-item" *ngIf="pages && pages.page1">
    <a class="nav-link gtmAssetLibraryPromoContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 2}"
      (click)="clickable?setIndex(2):false">
      <div class="page_container">
        <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page1">PAGE 1</span>&nbsp;</div>
        <div class="delete_page" *ngIf="pagelen > 1" (click)="tabIndex > 1 ? openPopup(delete,0): false"></div>
      </div>
      <!-- <span>PAGE 1</span> -->
    </a>
  </li>
  <li class="nav-item" *ngIf="pages && pages.page2">
    <a class="nav-link gtmAssetLibraryPromoContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
      (click)="clickable?setIndex(3):false">
      <div class="page_container">
        <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page2">PAGE 2</span>&nbsp;</div>
        <div class="delete_page" (click)="tabIndex > 1 ? openPopup(delete,1) : false"></div>
      </div>
      <!-- <span>PAGE 2</span> -->
    </a>
  </li>
  <li class="nav-item" *ngIf="pages && pages.page3">
    <a class="nav-link gtmAssetLibraryPromoContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
      (click)="clickable?setIndex(4):false">
      <div class="page_container">
        <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page3">PAGE 3</span>&nbsp;</div>
        <div class="delete_page" (click)="tabIndex > 1 ? openPopup(delete,2):false"></div>
      </div>
      <!-- <span>PAGE 3</span> -->
    </a>
  </li>
  <li class="nav-item" *ngIf="clickable && !checkPages()">
    <a class="nav-link gtmAssetLibraryPromoContentAddPage" data-toggle="tab" (click)="addPage()">
      <img class="checkPages" alt="add pages" />
    </a>
  </li>
  <li class="nav-item exit_preview">
    <a class="nav-link" (click)="cancelCreation(true, false)">
      <img class="exitPage" alt="exit without changes" />
    </a>
  </li>
</ul>


<!-- Main section -->

<!-- Create New promo section -->
<section *ngIf="tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4" class="main_section al_newpromo">
  <ng-container>
    <div id="promoLayout1" *ngIf="tabIndex === 1">
      <iposcen-new-partner-content (changedContentName)="contentNameDisplay = $event" (isAllSelectLang)="checkLangLenght($event)" (sendDataToPage)='getPages($event)' [editCG]="isEdit"
        (editDone)='editDoneConfig($event)' [getEditData]='editPartnerContentData' [isNavigated]="isNavigated"
        (goBacktoPromoContent)="setCreatedGrpID($event)" (goBacktoListPartnerContent)="setIndex(0)"
        (showAuthorTabs)="showHeaders($event)" [duplicacy] = "duplicacy" (isNewPartnerContent)="isNewPartnerContent.emit($event)">
      </iposcen-new-partner-content>
    </div>
    <div id="promoLayout2" *ngIf="tabIndex === 2">
      <iposcen-partner-content-page #page1 [getPageData]='pageData' [cntgrpdata]="contentGrpData"
        [contentGroupType]="pageType" [pageNumber]=1 [mediaObjs]="mediaObjects" (sendLayoutTocontentGrp)="setPreviewLayout($event)"
        (sendImageValues)="showImageValue($event)"></iposcen-partner-content-page>
    </div>
    <div id="promoLayout3" *ngIf="tabIndex === 3">
      <iposcen-partner-content-page #page2 [getPageData]='pageData' [cntgrpdata]="contentGrpData"
        [contentGroupType]="pageType" [pageNumber]=2 [mediaObjs]="mediaObjects" (sendLayoutTocontentGrp)="setPreviewLayout($event)"
        (sendImageValues)="showImageValue($event)"></iposcen-partner-content-page>
    </div>
    <div id="promoLayout4" *ngIf="tabIndex === 4">
      <iposcen-partner-content-page #page3 [getPageData]='pageData' [cntgrpdata]="contentGrpData"
        [contentGroupType]="pageType" [pageNumber]=3 [mediaObjs]="mediaObjects" (sendLayoutTocontentGrp)="setPreviewLayout($event)"
        (sendImageValues)="showImageValue($event)"></iposcen-partner-content-page>
    </div>
  </ng-container>
  <div id="promoLayoutActionBtn" class="pages_tabs">
    <div id="promoLayoutBtnWrapper" class="button-wrapper pages_button" *ngIf="tabIndex === 2 || tabIndex === 3|| tabIndex === 4">
      <button type="button" class="btn btn-outline-primary left_icon_btn" (click)="addPage()" *ngIf="!isPage3Created">
        <img class="addPage" alt="add page" />
        <span i18n="@@create-partner-content.main-section.add-page">Add Page</span>
      </button>
      <button [disabled]="disableSave" type="button" class="btn btn-primary" (click)="updatePCG()">
        <span class="gtmSavePromoContGrp" i18n="@@create-partner-content.main-section.save-proceed">Save and Proceed</span>
      </button>
    </div>
  </div>
</section>

<!-- //popup page delete  -->
<ng-template #delete let-modal>
  <div id="confrmPopUp" class="card confirmPopup">
    <div id="modalHeader" class="modal-header">
      <div id="modalCloseIcon" (click)="modal.close()" class="close-icon">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="modalBody" class="modal-body popup-body">
      <div id="modalBodyTitle">
        <h2 class="mt-3">
          <span i18n="@@create-partner-content.delete-modal.delete-page?">Delete Page?</span>
        </h2>
        <div id="modalBodyText" class="card-desc">
          <span i18n="@@create-partner-content.delete-modal.remove-permanently">This content will be removed permanently.</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@create-partner-content.delete-modal.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="modal.close();deletePages(whichPageDelete)">
        <span i18n="@@create-partner-content.delete-modal.delete-page">Delete Page</span>
      </button>
    </div>
  </div>
</ng-template>